import * as XLSX from 'xlsx';

/** Excel sheet names are limited to 31 characters and cannot contain certain characters. */
function sanitizeSheetName(name: string): string {
  const n = name.slice(0, 31);
  return n.replace(/[:\\/?*[\]]/g, '');
}

/**
 * Builds a single-sheet workbook from an array-of-arrays matrix (header row first).
 * Shared by Organisation Leave, Organisation Workforce, and any future client-side Excel exports.
 */
export function buildWorkbookFromAoA(
  sheetName: string,
  aoa: (string | number | boolean)[][],
  columnWidthsCh?: number[]
): XLSX.WorkBook {
  const ws = XLSX.utils.aoa_to_sheet(aoa);
  if (columnWidthsCh?.length) {
    ws['!cols'] = columnWidthsCh.map((wch) => ({ wch }));
  }
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sanitizeSheetName(sheetName));
  return wb;
}

export function downloadExcelWorkbook(wb: XLSX.WorkBook, filename: string): void {
  XLSX.writeFile(wb, filename);
}

/** Convenience: matrix → workbook → browser download. */
export function downloadExcelFromAoA(
  filename: string,
  sheetName: string,
  aoa: (string | number | boolean)[][],
  columnWidthsCh?: number[]
): void {
  const wb = buildWorkbookFromAoA(sheetName, aoa, columnWidthsCh);
  downloadExcelWorkbook(wb, filename);
}
